import { StatelessComponent, useRef } from 'react'
import * as styles from 'components/features/pfm/SpendingPage/SpendingPage.styl'
import { MoneyflowPageProps } from 'interfaces/moneyflow'
import MoneyflowCategoriesModuleContainer from 'components/features/pfm/CategoriesModule/MoneyflowCategoriesModuleContainer'
import MoneyflowBreakdownModuleContainer from 'components/features/pfm/MoneyflowBreakdown/MoneyflowBreakdownModuleContainer'
import TransactionsModuleContainer from 'components/features/pfm/TransactionsModule/TransactionsModuleContainer'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import ModuleWrapper from 'components/features/pfm/ModuleWrapper/ModuleWrapper'
import Anchor from 'components/atoms/navigation/Anchor'
import PageFooterButton from 'components/atoms/buttons/PageFooterButton'
import TrendRankContainer from 'components/features/pfm/TrendRank/TrendRankContainer'
import { DEFAULT_TRANSACTIONS_SORTING, EMPTY_PIE_CHART_LABEL } from 'constants/moneyflow'
import { createSeeAllCategoriesButton, useShouldShowPageParamsStickyHeader } from 'helpers/pageHelpers'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { PageParamsStickyHeader } from 'components/features/pfm/PageParamsHeader/PageParamsStickyHeader'
import { PageParamsHeader } from 'components/features/pfm/PageParamsHeader/PageParamsHeader'
import { DesktopInternalStickyHeader } from 'components/features/pfm/DesktopInternalStickyHeader/DesktopInternalStickyHeader'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import { EditTrackerButton } from 'components/features/pfm/EditTrackerButton/EditTrackerButton'

const IncomePage: StatelessComponent<MoneyflowPageProps> = (props) => {
  const {
    timeframe,
    categoryId,
  } = props

  const pageBody = (
    <>
      <div className={ styles.topButtonWrapper }>
        <EditTrackerButton type='income' categoryId={ categoryId } timeframe={ timeframe } />
      </div>

      <TrendRankContainer type='income' timeframe={ timeframe } categoryId={ categoryId } />

      <div className={ styles.buttonWrapper }>
        <EditTrackerButton type='income' categoryId={ categoryId } timeframe={ timeframe } />
      </div>

      <ModuleWrapper
        title='Income Categories'
        anchor='income_categories'
        action={ createSeeAllCategoriesButton('income_categories') }
      >
        <MoneyflowCategoriesModuleContainer
          type='income'
          timeframe={ timeframe }
          piePlaceholderLabel={ EMPTY_PIE_CHART_LABEL }
        />
      </ModuleWrapper>

      <ModuleWrapper
        title='Breakdown by Category'
        anchor='income_breakdown'
        card={ false }
        action={ createSeeAllCategoriesButton('income_breakdown') }
      >
        <MoneyflowBreakdownModuleContainer type='income' timeframe={ timeframe } categoryId={ categoryId } />
      </ModuleWrapper>

      <ModuleWrapper
        title='Transactions'
        card={ false }
        anchor='income_details'
        action={ createSeeAllCategoriesButton('income_details') }
      >
        <TransactionsModuleContainer type='income' defaultSorting={ DEFAULT_TRANSACTIONS_SORTING } />
      </ModuleWrapper>

      <PageFooterButton text='See Your Debts' to='debts' />
    </>
  )

  const staticHeaderRef = useRef<HTMLDivElement>(null)
  const shouldShowStickyHeader = useShouldShowPageParamsStickyHeader(staticHeaderRef)

  const notifications = (
    <NotificationTrayWrapper
      renderLevel='page'
      placement='income_general'
      isPositionRelative
    />
  )

  return (
    <InternalLayoutContainer
      sidebar={ <InternalSidebarContainer /> }
      notifications={ notifications }
      stickyHeader={ <PageParamsStickyHeader type='income' /> }
      shouldShowStickyHeader={ shouldShowStickyHeader }
    >
      <Anchor placement='income'>
        <Anchor placement='income_general'>
          <DesktopInternalStickyHeader isShown={ shouldShowStickyHeader }>
            <PageParamsStickyHeader type='income' />
          </DesktopInternalStickyHeader>
          <SingleColumnLayout
            header={ <PageParamsHeader type='income' nodeRef={ staticHeaderRef } /> }
          >
            { pageBody }
          </SingleColumnLayout>
        </Anchor>
      </Anchor>
    </InternalLayoutContainer>
  )
}

export default IncomePage
